import React from "react";

const About = () => {
  return (
    <>
      <h3>About Shelly!</h3>
      <p>
        Here is where Shelly's story goes. Where we got her, her terrible sickly
        condition when we got her, having puppies, adoption, allergic to
        everything, etc.
      </p>
    </>
  );
};

export default About;
